import React from "react";
import { SeatItem } from "@components/index";
import { IRacket, ISelctedRacket } from "@redux/rent/types";
import { isSeatTimesUp } from "@utils/date/racketRentDate";
import styles from "./RacketList.module.scss";

interface RacketListProps {
  rackets: IRacket[];
  date: string;
  quantity: number;
  activeRacketTime: string | null;
  onRacketSelect: (newSelectedRackets: { [key: string]: ISelctedRacket }, clickedTime?: string | null) => void;
}

export const RacketList: React.FC<RacketListProps> = (props: RacketListProps) => {
  const { rackets, date, quantity, activeRacketTime, onRacketSelect } = props;

  if (!rackets || !Array.isArray(rackets)) {
    return null;
  }

  return (
    <div className={styles.table_container}>
      {rackets.map((racket: IRacket) => {
        const timesUpThisSeat = isSeatTimesUp(racket.startTime, date);
        const unAvailableThisSeat = racket.available_count === 0;

        return (
          <div key={racket.time_id} id={`${racket.time_id}`}>
            <SeatItem
              data={{
                date: date,
                id: +racket.time_id.split(":")[0],
                count: quantity,
                price: racket.price,
                time: racket.time_id,
                title: racket.time_id,
                available: racket.available_count,
                created_at: racket.startTime,
                updated_at: racket.finishTime,
                startTimeRacket: racket.startTime,
                padel: racket.padel,
              }}
              onClickFunc={onRacketSelect}
              disabled={timesUpThisSeat || unAvailableThisSeat}
              activeRacketTime={activeRacketTime}
              selectedCount={racket.selectedCount}
            />
          </div>
        );
      })}
    </div>
  );
};

